var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 mx-auto"},[_c('div',[_c('action-register',{attrs:{"showPinButton":true,"all":_vm.all}})],1),_c('div',[_c('audit-register',{attrs:{"showPinButton":true,"all":_vm.all}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }